(function () {
  if (window.__nfFriends) return;
  window.__nfFriends = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Review notes show only with ?notes=1
    if (/[?&]notes=1/.test(location.search)) document.documentElement.classList.add('nf-notes-on');

    // Wall filters: chips filter cards by data-tags (space separated)
    document.querySelectorAll('[data-nf-filters]').forEach(function (bar) {
      var grid = document.getElementById(bar.getAttribute('data-nf-filters'));
      if (!grid) return;
      var count = document.querySelector('[data-nf-count="' + grid.id + '"]');
      bar.addEventListener('click', function (e) {
        var chip = e.target.closest('button[data-f]');
        if (!chip) return;
        bar.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-on', b === chip); });
        var f = chip.getAttribute('data-f');
        var shown = 0;
        grid.querySelectorAll('.nf-card').forEach(function (card) {
          var tags = ' ' + (card.getAttribute('data-tags') || '') + ' ';
          var on = !f || tags.indexOf(' ' + f + ' ') > -1;
          card.hidden = !on;
          if (on) shown++;
        });
        if (count) count.textContent = shown + ' ' + (shown === 1 ? (count.getAttribute('data-one') || 'friend') : (count.getAttribute('data-many') || 'friends'));
      });
    });

    // Lineup: no separator dot at the start of a wrapped line
    var rows = document.querySelectorAll('.nf-lineup__row');
    function markLines() {
      rows.forEach(function (row) {
        var prevTop = null;
        row.querySelectorAll('span').forEach(function (s) {
          s.classList.toggle('nf-lf', prevTop !== null && Math.abs(s.offsetTop - prevTop) > 4);
          prevTop = s.offsetTop;
        });
      });
    }
    if (rows.length) {
      markLines();
      var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(markLines, 120); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(markLines);
    }

    // Copy code buttons
    document.querySelectorAll('[data-nf-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-nf-copy');
        var done = function () { var t = btn.textContent; btn.textContent = btn.getAttribute('data-done') || 'Copied'; setTimeout(function () { btn.textContent = t; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      });
    });

    // Muted loops play only while on screen
    var vids = document.querySelectorAll('.nf video[data-nf-loop]');
    if ('IntersectionObserver' in window && vids.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        io.observe(v);
      });
    }
  });
})();
